/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import muiStyles from './styles';
import TransactFundsForm from './TransactForm';

export default withStyles(muiStyles)(TransactFundsForm);